import {NgModule} from '@angular/core';
import {PhonePipe} from './phone.pipe';
import {SsnPipe} from './ssn.pipe';
import {DobPipe} from './dob.pipe';
import {FromISOPipe} from './from-iso.pipe';
import {DateFormatPipe} from './date-format.pipe';
import {FromUtcPipe} from './from-utc.pipe';
import {LocalTimePipe} from './local.pipe';
import {SsnFormatInputPipe} from './ssn-format-input.pipe';
import { CurrencyPipe } from '@angular/common';

const CUSTOM_PIPES = [
  PhonePipe,
  SsnPipe,
  DobPipe,
  DateFormatPipe,
  FromISOPipe,
  FromUtcPipe,
  LocalTimePipe,
  SsnFormatInputPipe
];


@NgModule({
  declarations: CUSTOM_PIPES,
  exports: CUSTOM_PIPES,
  providers: CUSTOM_PIPES
})

export class PipesModule {
}
